import React from 'react';
import { connect } from 'react-redux';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import withStyles from 'react-jss';
import { getOnboardingState, getTenantState } from '../../../store/selectors';

const bulletColoring = {
  color: (props) => ({
    '&::before': {
      color: props.color,
    },
  }),
};

// Need to know which career card this will be for so use the cardNumber prop
// TODO: Figure out if we'll EVER be in a situation where there are no tasks associated with a career and \
// what we should display instead
function CareerChoiceBullets(props) {
  const dynamicClass = props.classes.color;
  const { t } = useTranslation();

  // Build array of tasks
  const careerTasks = () => {
    const taskArray = [];
    // The way the tasks are saved as JSON objects in the b/e starts with index = 1
    const listItem = props.onboarding.careerChoices[props.cardNumber].tasks ? (
      Object.values(props.onboarding.careerChoices[props.cardNumber].tasks).map(
        (task) => {
          return (
            <li
              className={['expand-info-long-text', dynamicClass].join(' ')}
              // Maybe way too complicated of a way to generate a key?
              key={`${props.cardNumber} + ${Math.random()}`}
            >
              {task}
            </li>
          );
        }
      )
    ) : (
      <li
        className={['expand-info-long-text', dynamicClass].join(' ')}
        // Maybe way too complicated of a way to generate a key?
        key={`${props.onboarding.careerChoices[props.cardNumber]}`}
      >
        Lorem ipsum dolor sit amet, consectetur adipiscing elit.
      </li>
    );

    taskArray.push(listItem);

    return taskArray;
  };

  return (
    <div className="expand-info-bullets-container">
      <ul className={['expand-info-long-text-list', dynamicClass].join(' ')}>
        {careerTasks()}
      </ul>
    </div>
  );
}

CareerChoiceBullets.propTypes = {
  color: PropTypes.string.isRequired,
};

function mapStateToProps(state) {
  const onboarding = getOnboardingState(state);
  const tenant = getTenantState(state);

  return { onboarding, tenant };
}

export default connect(mapStateToProps)(
  withStyles(bulletColoring)(CareerChoiceBullets)
);
